<hb-modal-dialog
  [heading]="'Widgets.AddDashboardWidget' | i18next"
  [showFooter]="true"
  [okDisabled]="selectedWidgetDataType === null"
  (okClicked)="apply()"
>
  <div content class="form-container">
    <div class="form-group row">
      <div class="col-md-5">
        <label class="form-control-label">{{ 'Widgets.WidgetType' | i18next }}</label>
      </div>
      <div class="col-md-8">
        <select class="form-control" name="selectedWidgetDataType" [(ngModel)]="selectedWidgetDataType">
          <option [ngValue]="null" disabled>{{ 'Widgets.SelectWidgetType' | i18next }}</option>
          <option *ngFor="let widgetDataType of widgetDataTypes" [ngValue]="widgetDataType.key">
            {{ widgetDataType.value }}
          </option>
        </select>
      </div>
    </div>
  </div>
</hb-modal-dialog>
